import { render, staticRenderFns } from "./reg-wallet-5.vue?vue&type=template&id=828119fa&lang=pug&"
import script from "./reg-wallet-5.vue?vue&type=script&lang=js&"
export * from "./reg-wallet-5.vue?vue&type=script&lang=js&"
import style0 from "./reg-wallet-5.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports